import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, lifecycle, renderComponent, withProps } from 'recompose';
import { cpdActivityMap, routes } from '../../../../../constants';
import { isBusinessAdmin, isBusinessUser } from '../../../../../services';
import { currentUserSelector } from '../../../../../state/modules/user';
import { Icon } from '../../../../components';
import { CpdActivityTable } from '../components';

const UnpopulatedCpdActivity = () => (
  <div className='profile--cpd-activity no-content'>
    <div className='inner'>
      <span>
        <Icon icon='cpd-activity-large' />
      </span>
      <h2>CPD activity</h2>
      <p>
        You haven’t logged any activity yet. Log some activity or head over to training to start earning CPD.
      </p>
      <p className='buttons'>
        <LinkContainer to={routes.app.training.home}>
          <Button>
            Go to training <Icon icon='chevron-right-large' />
          </Button>
        </LinkContainer>
      </p>
    </div>
  </div>
);

const PopulatedCpdActivity = ({ user, currentUser, cpdActivity, rejectText, isReview, detailPageRoute, unclickable }) => (
  <div className='profile--cpd-activity'>
    <div className='inner'>
      <h2>
        <Icon icon='cpd-activity-large' /> CPD activity
      </h2>
      {
        !isReview ?
          <div className='main-button'>
            <LinkContainer to={routes.app.externalCpd.details}>
              <Button>
                Add External CPD <Icon icon='add-large' />
              </Button>
            </LinkContainer>
            <LinkContainer to={routes.app.professionalProfile.progressReport}>
              <Button>
                Progress Report <Icon icon='chevron-right-large' />
              </Button>
            </LinkContainer>
          </div> :
          <div className='main-button'>
            <LinkContainer to={routes.app.teams.allTeamMemberReport(user.id)}>
              <Button>
                Progress Report <Icon icon='chevron-right-large' />
              </Button>
            </LinkContainer>
          </div>
      }
      <CpdActivityTable
        className='table--cpd-activity'
        cpdActivity={cpdActivity}
        unclickable={unclickable}
        cpdActivityMap={cpdActivityMap(rejectText, isBusinessAdmin(currentUser) || !isReview, { review: isReview, userId: user.id })} />
      <Row className='no-gutter row-slider'>
        <Col xs={12} md={4} mdOffset={4}>
          <LinkContainer
            className='full'
            to={detailPageRoute}>
            <Button>
              See all CPD activity <Icon icon='chevron-right-large' />
            </Button>
          </LinkContainer>
        </Col>
      </Row>
    </div>
  </div>
);

export default compose(
  connect((state) => ({
    currentUser: currentUserSelector(state),
    isFetchingCpdActivity: state.cpdPoints.isFetching,
    industryCpdCategorys: state.industry.cpdCategorys
  })),
  branch(
    ({ industryCpdCategorys }) => fp.isEmpty(industryCpdCategorys),
    renderComponent(UnpopulatedCpdActivity)
  ),
  lifecycle({
    componentDidMount() {
      const {
        industryCpdCategorys,
        getCpdPoints,
        isFetchingCpdActivity
      } = this.props
      if (!isFetchingCpdActivity) {
        const industryCpdCategoryIdQuery = fp.map('id')(industryCpdCategorys).join(',')
        getCpdPoints({
          skip: 0,
          take: 6,
          cpdCategorys: industryCpdCategoryIdQuery
        });
      }
    }
  }),
  branch(
    ({ cpdActivity, isFetchingCpdActivity }) => isFetchingCpdActivity || !cpdActivity || !cpdActivity.length,
    renderComponent(UnpopulatedCpdActivity)
  ),
  withProps(({ user, currentUser }) => ({
    isReview: user.id !== currentUser.id,
    rejectText: isBusinessUser(user) ? "(rejected)" : "(draft)"
  }))
)(PopulatedCpdActivity);



// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/partials/populated-cpd-activity.js